import React from 'react';
import HashHero from 'hash-heroes';
import './App.css';

const heroStyle = {
    margin: '0 auto',
}

const MyHero = ({seed}) => {
    return (
        <div className="my-hero">
            <HashHero style={heroStyle} seed={seed} scalingFactor={4} />
            <p className="my-hero-text"> Your Hero </p>
        </div>
    );
}

export default MyHero;



// WEBPACK FOOTER //
// ./src/components/MyHero.js